<template>
	<div class="tabs-form">
    <div _bg="[#ffffff]" _m="b-10px" _p="15px">
      <div class="ability-detail-header" @click="routeBack" >
        <i class="el-icon-arrow-left" style="margin-right: 5px;font-weight: 1000;"></i>返回
      </div>
      <div _m="15px" _p="t-10px">
        <div _text="[#272727] 20px" _m="b-10px"><b>课件名称：{{ detail?.name }}</b></div>
        <div>激活码数量：{{ detail?.num }}</div>
      </div>
    </div>

		<el-form :inline="true" class="form" ref="form">
			<div>
				<el-form-item prop="license">
          <InputTopTip v-model="searchParams.license" placeholder="激活码">
            <el-input
              v-model="searchParams.license"
              class="width-264"
              @keydown.enter.native.prevent="(page = 1), searchResult()"
              placeholder=""
              size="small"
            ></el-input>
          </InputTopTip>
        </el-form-item>
        <el-form-item prop="account">
          <InputTopTip v-model="searchParams.account" placeholder="教师账号">
            <el-input
              v-model="searchParams.account"
              class="width-264"
              @keydown.enter.native.prevent="(page = 1), searchResult()"
              placeholder=""
              size="small"
            ></el-input>
          </InputTopTip>
        </el-form-item>
        <el-form-item prop="mobile">
          <InputTopTip v-model="searchParams.mobile" placeholder="手机号码">
            <el-input
              v-model="searchParams.mobile"
              class="width-264"
              @keydown.enter.native.prevent="(page = 1), searchResult()"
              placeholder=""
              size="small"
            ></el-input>
          </InputTopTip>
        </el-form-item>
			</div>
			<el-form-item class="form-reset">
				<el-button
					type="primary"
					@click=";(page = 1), searchResult()"
					size="small"
					class="action-btn"
					style="margin-right: 15px; width: 70px;"
					>搜索</el-button
				>
				<el-button @click="resetForm('form')" size="small" style="width: 70px;">重置</el-button>
			</el-form-item>
		</el-form>

		<div class="table" >
			<el-table stripe style="width: 100%; min-height: 570px;" :data="tableData">
        <el-table-column prop="license_id" label="课件激活码" width="300px"></el-table-column>
        <el-table-column label="使用状态">
          <template slot-scope="scope">
						<div :class="['scope-all', scope.row?.using?.id ? 'scope-green' : 'scope-grey']">
							{{ formatter_status(scope.row) }}
						</div>
          </template>
        </el-table-column>
        <el-table-column label="辖区" :formatter="formatter_address" width="250px"></el-table-column>
        <el-table-column label="学校" :formatter="formatter_school"></el-table-column>
        <el-table-column label="教师" :formatter="formatter_teacher"></el-table-column>
        <el-table-column label="教师账号" :formatter="formatter_login"></el-table-column>
        <el-table-column label="手机号码" :formatter="formatter_phone" width="180px"></el-table-column>
        <el-table-column label="转移时间" :formatter="formatter_time" width="180px"></el-table-column>
			</el-table>
			<div class="pagination">
				<div>总计：{{ total }}条/{{ last_page }}页</div>
				<el-pagination
					:current-page.sync="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="page_size"
					:total="total"
					background
					layout="prev, pager, next, jumper, sizes, slot"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
				>
				</el-pagination>
			</div>
		</div>

	</div>
</template>
<script>
import { mapValues } from 'lodash'
export default {
	data() {
		return {
      page: 1,
			page_size: 10,
			last_page: '',
      total: 0,
      searchParams: {
        license: '',
        mobile: '',
        account: ''
      },
      tableData: [],
      detail: {}
    }
	},
	mounted() {
    this.detail = this.$route.query
    // 从列表页通过 query 带过来的激活码搜索值
    if (this.$route.query?.license) {
      this.searchParams.license = this.$route.query.license
    }
    this.searchResult()
	},
	methods: {
    formatter_status(row) {
      return row.using?.id ? '已使用' : '待使用'
    },
    formatter_address(row) {
      const district_division = row.using?.extra?.school?.district_division
      let address
      if (district_division) {
        if (district_division.l3_name) address = district_division.l1_name + ' / ' + district_division.l2_name + ' / ' + district_division.l3_name
        else address = district_division.l1_name + ' / ' + district_division.l2_name
      } else {
        address = '暂无'
      }
      return address
    },
    formatter_school(row) {
      return row.using?.extra?.school?.name || '暂无'
    },
    formatter_teacher(row) {0
      return row.using?.teacher?.realname || '暂无'
    },
    formatter_login(row) {0
      return row.using?.teacher?.login_name || '暂无'
    },
    formatter_phone(row) {
      return row.using?.teacher?.mobile || '暂无'
    },
    formatter_time(row) {
      return row.using?.created_at || '暂无'
    },
    handleCurrentChange(val) {
      this.page = val
      this.searchResult()
    },
    handleSizeChange(val) {
      this.page = 1
      this.page_size = val
      this.searchResult()
    },
    // 列表搜索
    async searchResult() {
      const params = {
				...this.searchParams,
				page_size: this.page_size,
				page: this.page,
        textbook_id: this.$route.query.textbook_id
      }
      // this.$store.commit('setSearchParams', { key: this.$route.name, params})
			const data = await this.$api.user.httpGet(`textbook-license-batch/${this.$route.params.id}`, params)
			this.tableData = data.data
			this.total = data.meta.total
			this.last_page = data.meta.last_page
    },
    resetForm(formName) {
			this.$refs[formName].resetFields()
      this.searchParams = mapValues(this.searchParams, () => '')
      this.page = 1
			this.searchResult()
		},
    routeBack() {
			this.$router.go(-1)
		},
  },
}
</script>
<style scoped lang="scss">
.form {
	padding: 15px 0px 0px 19px !important;
	display: flex;
	justify-content: space-between;
	min-height: 40px;
	background: #ffffff;
}
.table {
	margin-top: 10px;
	padding: 20px;
	display: block;
	background: #ffffff;
}
.pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 26px;
}
.width-264 {
	width: 264px;
}
.ability-detail-header {
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
}
.ability-detail-header:hover {
  color: #ff5e2a;
}
.scope-all {
  display: flex;
  align-items: center;
}
.scope-grey::before {
	content: '';
	display: inline-block;
	width: 7px;
	height: 7px;
	background: grey;
	border-radius: 100%;
	margin-right: 5px;
}
.scope-green::before {
	content: '';
	display: inline-block;
	width: 7px;
	height: 7px;
	background: #42ba1a;
	border-radius: 100%;
	margin-right: 5px;
}
</style>
